import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'language/i18n';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import LeftMenu from '../components/buying/LeftMenu';
import AuctionMethodsFeature from '../components/buying/AuctionMethodsFeature';
import ContactUs from '../components/ContactUs';
import BuyForOfferMachine from '../components/BuyForOfferMachine';

const AuctionMethods = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('buying'),
      url: '/content/buying/before-bidding',
    },
    {
      label: 'Açık Artırma Yöntemleri',
      url: '/content/buying/auction-methods',
    },
  ];

  const items = {
    bergainAuction: {
      title: '1. Pazarlık Usulü Açık Artırma',
      svgIcon: '/image/icons.svg#ic-auction2-yellow',
      descriptions: [
        'Açık artırma başlangıç-bitiş saati sistemi ile çalışmaktadır. Erken kapanışa tabidir.',
        'Açık artırmanın başlamasına istinaden alıcılar teklif verebilir.',
        'Açık Artırmalar ayın ilk günü başlar (Her ayın 1\'inde) ve ayın son günü biter.',
        'Araya hafta sonu girse bile açık artırma süresi bundan etkilenmez. Başlangıç ve bitiş tarihi haftasonu da olabilir.',
        'Açık artırma sonucu herkes tarafından görülebilir.',
        'Bitiş fiyatı ve verilen teklifleri alıcılar şeffaf bir şekilde görebilirler.',
        'Açık artırmada alıcılar, "Hemen Al" teklifi vererek anında makina sahibi olabilir ve açık artırmayı erken kapatabilirler.',
        'Başlangıç fiyatı bitiş fiyatının belirli bir oran altında olur.',
        'Açık artırmanın son 2 dakikasında verilen teklifler açık artırma süresini 2 dakikaya sıfırlar. Uzatmalar kullanıcılardan yeni teklif gelmeyene kadar tekrarlanır.',
        'Gelen teklif sisteme girilen rezerv fiyata ulaştığında makina otomatik olarak satışa geçmektedir.',
        'Açık artırma bittiğinde; verilen en yüksek teklif rezerv fiyatına ulaşmaz ise; satıcı alıcıya sistem üzerinden karşı teklif verebilir. Kullanıcı; gelen karşı teklifi reddedebilir, kabul edebilir veya satıya revize teklifini iletebilir. Rezerv fiyata ulaşamayan makinalarda; alıcı ve satıcı arasında sistem üzerinden pazarlık yapılabilir.',
      ],
    },
    timedAuction: {
      title: '2. Zaman Ayarlı Açık Artırma',
      svgIcon: '/image/icons.svg#ic-time-yellow',
      descriptions: [
        'Açık artırma başlangıç-bitiş saati sistemi ile çalışmaktadır.',
        'Açık artırmanın başlamasına istinaden alıcılar teklif verebilir.',
        'Açık Artırmalar ayın ilk günü başlar (Her ayın 1\'inde) ve ayın son günü biter.',
        'Araya hafta sonu girse bile açık artırma süresi bundan etkilenmez. Başlangıç ve bitiş tarihi haftasonu da olabilir.',
        'Açık artırma sonucu herkes tarafından görülebilir.',
        'Bitiş fiyatı ve verilen teklifleri alıcılar şeffaf bir şekilde görebilirler.',
        'Açık artırmaya katılarak teklif veren kullanıcılar arasında açık artırma sonucunda en yüksek teklifi veren kullanıcı, mimimun satılabilir fiyatı geçerse makinayı almaya hak kazanır.',
        'Başlangıç fiyatı bitiş fiyatının belirli bir oran altında olur.',
        'Açık artırmanın son 2 dakikasında verilen teklifler açık artırma süresini 2 dakikaya sıfırlar. Uzatmalar kullanıcılardan yeni teklif gelmeyene kadar tekrarlanır.',
        'Açık artırma bitene kadar makinaya teklif verebilebilir.',
        'Açık artırma bittiğinde; verilen en yüksek teklif sisteme girilen rezerv fiyatına ulaşmaz ise; makina bir sonraki açık artırma için beklemeye alınır.',
        'Açık artırmaya katılan kullanıcılar; belirledikleri maksimum fiyata kadar otomatik olarak teklif ver özelliği ile teklif verebilirler. Kullanıcıların belirledikleri maksimum teklif tutarına ulaşıncaya kadar; sistem tarafından belirlenen artış tutarınca teklif revize edilerek otomatik olarak verilir.',
      ],
    },
  };

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <LeftMenu currentPage="auction-methods" />
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Açık Artırma Yöntemleri</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  iyiMakina.com üzerinden satışa çıkan makinalar online açık artırmalara dahil olur.
                  Makinaları satın almak isteyen alıcılar, online açık artırmalar aracılığıyla istedikleri makinaya, istedikleri fiyatı teklif ederler.
                </p>
                <p>
                  iyiMakina.com'da gerçekleşen tüm açık artırmalar önceden duyurulan gün ve saatte online olarak yapılır.
                  Teklif veren kullanıcıların ödediği Teminat Bedeli aracılığıyla, manipülasyon olmadan, güvenli ve hızlı alım-satım gerçekleşir.
                </p>
                <p>
                  iyiMakina'da kullanıcılar; "Pazarlık Usulü" ve "Zaman Ayarlı Açık Artırma" olmak üzere iki çeşit açık artırma ile karşılaşabilirler.
                </p>
              </div>
            </div>
            <div className="row mb-30" style={{ rowGap: '20px' }}>
              <div className="col-15 col-lg">
                <AuctionMethodsFeature data={items.bergainAuction} />
              </div>
              <div className="col-15 col-lg">
                <AuctionMethodsFeature data={items.timedAuction} />
              </div>
            </div>
            <BuyForOfferMachine />
            <ContactUs about="Açık Artırma Yöntemleriyle" />
          </div>
        </div>
      </div>
    </main>
  );
};

AuctionMethods.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Açık Artırma Yöntemleri',
    },
  };
};

AuctionMethods.Layout = Layout;

export default withTranslation('common')(AuctionMethods);
